import React from "react";
import { Link } from "react-router-dom";
import {
  FaAmazon,
  FaEtsy,
  FaEbay,
  FaStore,
  FaShoppingBag,
  FaShoppingCart,
  FaTrophy,
  FaChartLine,
  FaUsers,
  FaRocket,
  FaTags,
  FaHandshake,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import {
  stats,
  whyChooseUs,
  contact,
  marketplaceList,
} from "./accountData";

// Maps the `icon` key stored in accountData to a concrete react-icons element.
const ICON_MAP = {
  amazon: FaAmazon,
  etsy: FaEtsy,
  ebay: FaEbay,
  store: FaStore,
  bag: FaShoppingBag,
  cart: FaShoppingCart,
};

export const MarketplaceIcon = ({ icon, className }) => {
  const Cmp = ICON_MAP[icon] || FaStore;
  return <Cmp className={className} />;
};

// Icon set used for the (shared) "Why Choose Us" cards, in order.
const WHY_ICONS = [FaTrophy, FaChartLine, FaUsers, FaRocket, FaTags, FaHandshake];

export const SectionHead = ({ eyebrow, title, intro }) => (
  <div className="am-section-head" data-aos="fade-up">
    {eyebrow ? <span className="am-eyebrow">{eyebrow}</span> : null}
    <h2>{title}</h2>
    {intro ? <p>{intro}</p> : null}
  </div>
);

export const WhyChooseUs = ({ name }) => (
  <div className="am-section am-wrap">
    <SectionHead
      eyebrow="Why Choose Us"
      title={
        name
          ? `Why K2 for Your ${name} Account`
          : "Why Sellers Choose K2 E-Commerce Solutions"
      }
      intro="A dedicated, marketplace-trained team that treats your store like our own — measured by your sales, not by hours logged."
    />
    <div className="am-grid am-grid-3">
      {whyChooseUs.map((item, i) => {
        const Icon = WHY_ICONS[i % WHY_ICONS.length];
        return (
          <div className="am-card" data-aos="zoom-in" key={item.title}>
            <div className="am-card-icon">
              <Icon />
            </div>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        );
      })}
    </div>
  </div>
);

export const StatsBand = () => (
  <div className="am-stats">
    <div className="am-wrap">
      <div className="am-stats-grid">
        {stats.map((s) => (
          <div data-aos="zoom-in" key={s.label}>
            <div className="am-stat-value">{s.value}</div>
            <div className="am-stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const OtherMarketplaces = ({ currentSlug }) => {
  const others = marketplaceList.filter((m) => m.slug !== currentSlug);
  return (
    <div className="am-section am-wrap">
      <SectionHead
        eyebrow="More Marketplaces"
        title={
          currentSlug
            ? "We Manage Other Marketplaces Too"
            : "Marketplaces We Manage"
        }
        intro="One partner for every channel you sell on — pick a marketplace to see exactly how we grow your account there."
      />
      <div className="am-grid am-grid-4">
        {others.map((m) => (
          <Link
            className="am-mp-card"
            to={`/services/account-management/${m.slug}`}
            data-aos="zoom-in"
            key={m.slug}
          >
            <span className="am-mp-icon">
              <MarketplaceIcon icon={m.icon} />
            </span>
            <h4>{m.name}</h4>
            <p>{m.name} seller account management</p>
            <span className="am-mp-link">Learn more →</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export const FinalCta = ({
  heading = "Ready to Grow Your Business?",
  text = "Let's turn your e-commerce challenges into success stories. Connect with one of our experts for a free consultation and a strategic analysis of your account.",
}) => (
  <div className="am-section am-wrap">
    <div className="am-cta-box" data-aos="fade-up">
      <h2>{heading}</h2>
      <p>{text}</p>
      <div className="am-cta-row" style={{ justifyContent: "center" }}>
        <a className="am-btn am-btn-primary" href={contact.phoneTel}>
          Get Started
        </a>
        <a
          className="am-btn am-btn-outline"
          href={contact.whatsapp}
          target="_blank"
          rel="noreferrer"
        >
          Enquire Now
        </a>
      </div>
      <div className="am-contact-row">
        <span className="am-contact-item">
          <FaPhoneAlt />
          {contact.phones.join(" , ")}
        </span>
        <span className="am-contact-item">
          <FaEnvelope />
          {contact.email}
        </span>
        <span className="am-contact-item">
          <FaMapMarkerAlt />
          {contact.address}
        </span>
      </div>
    </div>
  </div>
);
